import React, { useState, useEffect, Fragment } from 'react';
import { Button, ButtonGroup, Row, Col, CardBody } from 'reactstrap';
import Tooltip from '@material-ui/core/Tooltip';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendar, faClipboardCheck, faCheck, faBan, faClock } from "@fortawesome/free-solid-svg-icons";
import Modal from '@material-ui/core/Modal';
import TextField from '@material-ui/core/TextField';
import AlertModal from '../../../shared/components/Modal';

const PreviewImage = ({
    id_admision,
    decision,
    opened,
    closeDecision,
    Callback,
    sendNotificationImageApproveDecline
}) => {

    useEffect(() => {

    }, []);

    const [observationDecision, setObservationDecision] = useState("");
    const [showAlertModal, setAlerShowModal] = useState(false);
    const [messagAlerteModal, setAlertMessageModal] = useState(null);
    const [colorAlertModal, setAlertColorModal] = useState("success");

    const confirmDecisionForAllImages = async () => {
        const user = JSON.parse(sessionStorage.getItem('usuario'));
        let dataSend = {
            id_admision: id_admision,
            aprobacion: decision,
            doctor: user.id_usuario,
            observacion_doctor: observationDecision
        };
        await fetch(process.env.REACT_APP_PUBLIC_URL + 'archivos/cambiar-estado-todos', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify(dataSend)
        }).then(response => {
            if (response.status != 500 && response.status != 403 && response.status != 404) {
                return response.json();
            }
            else {
                throw new Error("Ha ocurrido un error en el Servidor");
            }
        }).then(data => {
            setAlertColorModal("success");
            if (decision == true) {
                setAlertMessageModal("Las imagenes se han APROBADO correctamente");
            }
            else {
                setAlertMessageModal("Las imagenes se han RECHAZADO correctamente");
            }
            setAlerShowModal(true);
        }).catch((error) => {
            console.error('Error:', error);
            setAlertColorModal("danger");
            setAlertMessageModal("Ha ocurrido un error en la aprobacion/rechazo de las Imagenes");
            setAlerShowModal(true);
        });
    }

    const onOkModal = () => {
        switch (colorAlertModal) {
            case "warning":
                confirmDecisionForAllImages();
                break;
            case "success":
                setAlerShowModal(false);
                setAlertMessageModal("");
                setAlertColorModal("info");
                sendNotificationImageApproveDecline(decision);
                closeModal();
                Callback();
                break;
            case "danger":
                setAlerShowModal(false);
                setAlertMessageModal("");
                setAlertColorModal("info");
                break;
        }
    }

    const onToggleModal = () => {
        switch (colorAlertModal) {
            case "warning":
                setAlerShowModal(false);
                setAlertMessageModal("");
                setAlertColorModal("info");
                break;
            case "success":
                setAlerShowModal(false);
                setAlertMessageModal("");
                setAlertColorModal("info");
                Callback();
                break;
            case "danger":
                setAlerShowModal(false);
                setAlertMessageModal("");
                setAlertColorModal("info");
                break;
        }
    }

    const closeModal = () => {
        setObservationDecision("");
        closeDecision();
    }

    const warningAlertModal = () => {
        setAlertColorModal("warning");
        if (decision == true) {
            setAlertMessageModal("Esta completamente seguro de APROBAR todas las Imagenes");
        }
        else {
            setAlertMessageModal("Esta completamente seguro de RECHAZAR todas las Imagenes");
        }
        setAlerShowModal(true);
    }

    return (<Fragment>
        <Modal
            open={opened}
            onClose={() => closeModal()}
            aria-labelledby="simple-modal-title"
            aria-describedby="simple-modal-description"
            style={{ zIndex: 1000, display: "block !important", }}
            disableScrollLock={false}
            disableEnforceFocus={true}
        >
            <div className="paperAppointment-flex" style={{ width: '100%', margin: 10 }}>
                <div>
                    <div className="card__title">
                        {decision == true ? <h5 className="bold-text">Aprobar Imagen</h5>
                            : <h5 className="bold-text">Rechazar Imagen</h5>
                        }
                    </div>
                    <div>
                        <TextField
                            required
                            style={{ width: '100%' }}
                            className="medical-material-form__field"
                            id="observation-standard-required"
                            label="Observacion"
                            type="text"
                            value={observationDecision}
                            onChange={(e) => {
                                setObservationDecision(e.target.value);
                            }}
                            InputLabelProps={{
                                style: { color: '#646777' }
                            }}
                        />
                    </div>
                </div>
                <br />
                <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <Button
                        style={{ marginRight: 10, marginLeft: 10 }}
                        variant="contained"
                        onClick={() => {
                            closeModal();
                        }}
                    >
                        Cerrar
                    </Button>
                    <Button
                        style={{ marginRight: 10, marginLeft: 10 }}
                        variant="contained"
                        color='primary'
                        onClick={() => {
                            warningAlertModal();
                        }}
                    >
                        Confirmar
                    </Button>
                </div>
            </div>

        </Modal>

        <AlertModal
            color={colorAlertModal}
            title={messagAlerteModal}
            modal={showAlertModal}
            onOk={() => {
                onOkModal();
            }}
            toggle={() => onToggleModal()}
        />
    </Fragment>)
}

export default PreviewImage;